import React from "react";
import Logo from "../assets/svg/krn.svg";
import * as HeaderStyles from "./css/Header.module.css";

const Header = () => {
  return (
    <header className={`flex w100 ${HeaderStyles.header}`}>
      <Logo />
    </header>
  );
};

export default Header;